import React, { FC } from 'react';
import { useBmisState } from '@packages/contexts/bmis';
import { PrintableContainer } from '@web/components/printable-container';
import { BmisPDFHeader } from './pdf-header';
import { BmisPDFBody } from './pdf-body';

export interface BmisPDFProps {
    componentRef: React.RefObject<HTMLDivElement>;
    isPrintLoading: boolean;
}

export const BmisPDF: FC<BmisPDFProps> = ({ componentRef, isPrintLoading }) => {
    const { selectedBmisRow } = useBmisState();

    return (
        <PrintableContainer
            ref={componentRef}
            allowPrint={isPrintLoading}
            header={<BmisPDFHeader />}
            body={selectedBmisRow ? <BmisPDFBody selectedBmisRow={selectedBmisRow} /> : null}
        />
    );
};
